export { VpMediaTitleInput } from './VpMediaTitleInput';
export { VpMediaDescriptionInput } from './VpMediaDescriptionInput';
export { VpMediaTagInput } from './VpMediaTagInput';
export { default as VpMediaTranscriptionInput } from './VpMediaTranscriptionInput';
export { VpMediaNameInput } from './VpMediaNameInput';
export { VpMediaFileSizeInput } from './VpMediaFileSizeInput';
export { VpMediaCaptionInput } from './VpMediaCaptionInput';



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/media-details/index.js